// extracted by mini-css-extract-plugin
module.exports = {"description":"VqY6QoGP5Dc8FKf3eeIWf","pageHeader":"TmaSHk7oiASGkGYMXM1D5","icon":"_1c_ifK4UUylLkMEzgjJlDO","container":"_3bV0SsXOG9QvR_ucdXXahx"};